import { useEffect, useState } from "react";
import { styles } from "./AppLink"

const AppLinkAndroid = () => {
    const [linkJson, setlinkJson] = useState()
    useEffect(() => {
        fetch(`${window.location.origin}/app/link.json`)
            .then((res) => {
                return res.json()
            }).then((data) => {
                setlinkJson(data)
            }).catch(err => console.log(err));
    }, []);
    return (
        <div>
            <div class="modal fade show AppDownloadModal" id="playstoreDownloadModal" tabindex="-1" aria-labelledby="exampleMdalLabel">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Download App</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div className='row'>
                                <div className='col-6' id='qr_retail_android' style={styles.borderDivider}>
                                    <div className='text-center'>
                                        RBI Retail Direct
                                    </div>
                                    <div style={styles.container}>
                                        <div className='m-2' >
                                            <img
                                                alt="QR code for RBI Retail Direct App"
                                                style={styles.qr}
                                                src="https://rbiretaildirect.org.in/common/img/png/primaryAndroid.png"
                                            // src={qrprimaryandroid}
                                            >
                                            </img>
                                        </div>
                                        <span className='downloadtext' onClick={() => window.open(linkJson?.primaryAndroid, '_blank')}>Download</span>
                                    </div>
                                </div>
                                <div className='col-6' id="qr_secondary_android" >
                                    <div className='text-center'>
                                        NDS-OM Retail</div>
                                    <div
                                        style={styles.container}>
                                        <div
                                            className='m-2' > <img alt="QR code for NDS-OM Secondary Market App"
                                                style={styles.qr}
                                                // src={qrsecondaryandroid}
                                                src="https://rbiretaildirect.org.in/common/img/png/secondaryAndroid.png"
                                            >
                                            </img>
                                        </div>
                                        <span className='downloadtext' onClick={() => window.open(linkJson?.secondaryAndroid, '_blank')}>Download</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}




export default AppLinkAndroid

